import React from 'react';
import { graphql } from 'gatsby';
import Container from '../../layout/container/container';
import Spacing from '../../layout/spacing/spacing';
import Carousel from '../../carousel/carousel';


const CardCarouselBlock = ({
  paddingTop,
  paddingBottom,
  background,
  ...props
}) => {
  return (
    <Container bg={background} gutters>
      <Spacing pt={paddingTop} pb={paddingBottom}>
        <Carousel {...props} location={location}/>
      </Spacing>
    </Container>
  );
};

export default CardCarouselBlock;

export const query = graphql`
  fragment CardCarouselBlock on DatoCmsCardCarouselBlock {
    id: originalId
    paddingTop
    paddingBottom
    background
    heading
    cards {
      heading
      text
      image {
        gatsbyImageData(imgixParams: { fit: "crop", w: "720", h: "760" })
      }
    }
    __typename
  }
`;
